var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWf16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2584 0C10.2204 0 10.1781 -1.2899e-07 10.0937 0.00844514C9.82766 0.0126678 9.6123 0.236467 9.6123 0.502493V9.86407C9.6123 10.1343 9.83188 10.3581 10.1064 10.3581H19.5059C19.7762 10.3581 20 10.1385 20 9.86407C19.9958 4.42532 15.6296 0 10.2584 0Z",
    fill: "#46324E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64955 10.2653V1.8411C8.64955 1.20348 8.05415 0.738993 7.43343 0.87834C2.9321 1.92133 -0.357334 6.12707 0.0311486 11.0296C0.40274 15.6702 4.16933 19.4453 8.81001 19.8169C13.6956 20.2096 17.8971 16.9497 18.9654 12.4652C19.1132 11.8445 18.6445 11.2449 18.0027 11.2449H9.63764C9.09715 11.2449 8.65377 10.8015 8.65377 10.261L8.64955 10.2653Z",
    fill: "#46324E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf16);
export default __webpack_public_path__ + "static/media/icon-wf-16.02877954ef5786246bfdcd26b295ba90.svg";
export { ForwardRef as ReactComponent };